import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { BaseButton } from '../../../../../BaseComponents';
const ExchangeRefundControls = ({ className, disabledContinue, onBack, onContinue }) => {
    const { t } = useTranslation('Exchange');
    const { ExchangeRefundControls: theme } = useTheme('Entities').Order;
    return (React.createElement("div", { className: cn(theme.root, className) },
        React.createElement(BaseButton, { className: theme.button, variant: "secondary", onClick: onBack, fullWidth: true }, t('Controls.Back')),
        !!onContinue && (React.createElement(BaseButton, { className: theme.button, variant: "action", disabled: disabledContinue, onClick: onContinue, fullWidth: true }, t('Controls.Continue')))));
};
export default ExchangeRefundControls;
